export const INC = "INC";
export const DEC = "DEC";
export const CRD = "CardPay";
export const COD = "CashOnDelivery";
export const BASEURL = process.env.REACT_APP_BASE_URL;
export const PRODUCTSURL = `${BASEURL}/products`;
export const PRODUCTDETAILURL = `${BASEURL}/productdetail`;
export const RECOMMENDATIONS = 12;